import React from 'react'
import { components } from 'cng-web-lib'
import CCNFormProperties from './CCNFormProperties'
import { Grid, Tooltip } from '@material-ui/core'

const {
  button: { CngIconButton }
} = components

const { initialValues } = CCNFormProperties.formikProps

function CCNEntry(props) {
  const {
    index,
    isLast,
    onAddCCN,
    onDeleteCCN,
    ccn,
    showNotification,
    shouldHideMap
  } = props
  
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md>
        <CCNFormProperties.Fields index={index} showNotification={showNotification} shouldHideMap={shouldHideMap} />
      </Grid>
      <Grid item xs={12} md='auto'>
        <Grid container spacing={1}>
          <Grid item xs='auto'>
            <Tooltip placement='bottom' title='Add new'>
              <span>
                <CngIconButton
                  icon={['fal', 'plus']}
                  onClick={() => onAddCCN(initialValues)}
                  size='small'
                  type='outlined'
                />
              </span>
            </Tooltip>
          </Grid>
          <Grid item xs='auto'>
            <Tooltip placement='bottom' title='Clone'>
              <span>
                <CngIconButton
                  icon={['fal', 'copy']}
                  onClick={() => onAddCCN({ ...ccn, _ccnId: undefined })}
                  size='small'
                  type='outlined'
                />
              </span>
            </Tooltip>
          </Grid>
          {!isLast && (
            <Grid item xs='auto'>
              <Tooltip placement='bottom' title='Delete'>
                <span>
                  <CngIconButton
                    icon={['fal', 'trash']}
                    onClick={() => onDeleteCCN(ccn)}
                    size='small'
                    type='outlined'
                  />
                </span>
              </Tooltip>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CCNEntry
